namespace Symbols {
  export const typeOf = Symbol("typeOf");
}

export default Symbols;
